import { render } from "./ShorterLayout.vue?vue&type=template&id=b03f1b38"
import script from "./ShorterLayout.vue?vue&type=script&lang=js"
export * from "./ShorterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__